import { render, staticRenderFns } from "./ConfirmationPhoneComponent.vue?vue&type=template&id=54f99cff&scoped=true&"
import script from "./ConfirmationPhoneComponent.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPhoneComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f99cff",
  null
  
)

export default component.exports